import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, vShow as _vShow, Transition as _Transition, vModelText as _vModelText, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex justify-between px-4 py-5 bg-gray-blue-50 dark:bg-gray-bluer-700 border-t-2 border-b-2 border-gray-blue-200 dark:border-gray-bluer-500" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center text-sm font-bold text-gray-bluer-200 hover:text-theme transition duration-150 ease-in-out cursor-pointer",
  style: {"flex-basis":"33.33%"}
}
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_5 = {
  class: "flex justify-center",
  style: {"flex-basis":"33.33%"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_10 = {
  class: "flex justify-end",
  style: {"flex-direction":"row","flex-basis":"33.33%"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_12 = {
  class: "absolute right-10 mt-2 w-80 rounded-md shadow-lg bg-white dark:bg-gray-bluer-600 ring-1 ring-black ring-opacity-5 focus:outline-none border border-transparent dark:border-gray-bluer-700 z-10",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "menu-button",
  tabindex: "-1"
}
const _hoisted_13 = { class: "flex items-center justify-between py-2 px-4 bg-gray-blue-200 dark:bg-gray-bluer-400 dark:text-white rounded-t-md" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Clear ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Filters", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Done ")
const _hoisted_17 = { class: "divide-y divide-gray-blue-500 dark:divide-gray-bluer-200" }
const _hoisted_18 = { class: "flex items-center space-x-3 py-3 px-4" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "text-sm font-medium" }
const _hoisted_21 = {
  key: 0,
  class: "flex px-4 py-5 bg-gray-blue-50 dark:bg-gray-bluer-700 border-b-2 border-gray-blue-200 dark:border-gray-bluer-500"
}
const _hoisted_22 = { class: "relative flex-1" }
const _hoisted_23 = { class: "pointer-events-none absolute inset-y-0 left-0 pl-5 flex items-center text-gray-bluer-100" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", { style: {"margin-top":"5px"} }, "Search All Files?", -1)
const _hoisted_26 = {
  key: 1,
  class: "relative py-24"
}
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 3,
  class: "p-10"
}
const _hoisted_29 = {
  key: 0,
  class: "text-lg leading-6 font-medium text-gray-bluer-400 dark:text-gray-blue-500 truncate"
}
const _hoisted_30 = { class: "p-5" }
const _hoisted_31 = {
  key: 0,
  class: "flex items-center justify-center error border rounded-sm mt-5"
}
const _hoisted_32 = { class: "flex flex-col items-center gap-3 max-w-xl text-center p-5" }
const _hoisted_33 = { class: "inline-flex shadow-sm text-gray-600 p-3 rounded-sm border border-gray-200 error" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary-700 font-medium" }, "Oops! "),
  /*#__PURE__*/_createTextVNode(" There has been an error when uploading the crop. Please try again. ")
], -1)
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "flex justify-center items-center rounded-md relative border mb-6 mt-5" }
const _hoisted_37 = { class: "inline-flex items-center gap-3 max-w-xl justify-start p-4" }
const _hoisted_38 = { class: "inline-flex shadow-sm text-gray-600 p-3 rounded-sm border border-gray-200" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "text-md" }, "Are you sure you want to replace the image with this crop?", -1)
const _hoisted_40 = { class: "items-center justify-center flex p-5 pb-8" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "flex justify-between" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Redo ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Confirm ")
const _hoisted_45 = { key: 2 }

import { onMounted, computed, ref, watch } from "vue";
import { useStore }                        from "vuex";
import { userHook }                        from "@/hooks/user";
import { useConfig }                       from "@ui/components/media/config";
import { MediaModel as Media }             from "@greywind/common";
import { load }                            from "./mixin";
import { useVueFuse }                      from 'vue-fuse';

// Components
import {
    AppButton as Button,
    AppButtonGroup as ButtonGroup,
    AppErrorEmpty as BlankCanvas,
    AppLoader as Loader,
    AppModal as Modal,
} from "@greywind/ui";

import {
    MediaFilesTable,
    MediaFilesList,
    MediaFilesGrid,
    MediaFilesPreview
} from './';
import {MediaEditor} from "../editor";


export default /*#__PURE__*/_defineComponent({
  props: {
        canDeleteFolder: {
            type:     Boolean,
            default:  true,
            required: false
        },
        canDownload: {
            type:     Boolean,
            default:  true,
            required: false
        },
        canReplace: {
            type:     Boolean,
            default:  true,
            required: false
        },
    },
  emits: ['replace'],
  setup(__props, { emit }) {

const props = __props



const store            = useStore();
const { config }       = useConfig();
const { activeEnvironment } = userHook( store );

const emptySearch = ref( false );

const searchTerm = ref('');
const allFilesSearchMode = ref(false);
const filters = ref([
    {   name: 'Has Alt Tag', 
        on: false, 
        handle: 'Greywind\\Apps\\Filters\\Options',
        type: 'select',
        options: { true: 'Yes', false: 'No'},
        value: 'All',
        key: 'alt',
        is_null_or_has: true
    },
    {   name: 'Date Taken', 
        on: false, 
        handle: 'Greywind\\Apps\\Filters\\Date',
        operators: {
            '<>' : 'is between',
            '>' : 'is after',
            '<' : 'is before',
            '=' : 'is equal to'
        },
        operatorValue: '<>',
        value: {from: null, to: null},
        key: 'date_taken'
    },
]);

const files    = computed( () => store.state.media.files );
const allFiles = computed( () => {
    return store.getters[ "media/allFiles" ];
} );
const modals   = computed( () => store.state.media.modals );
const loading  = computed( () => store.state.media.loading );

const {
          backPath,
          searchResults,
          allFilesSelected,
          selectedFiles,
          mode,
          activeFile,
          filteredFiles,
          setPath,
          setAllFilesSelected,
          setSelectedFiles,
          setFile,
          setModal,
          deleteFolder,
          deleteFile,
          selectFile,
          toggleAllFilesSelection,
          toggleFileSelection
      } = load( store );



onMounted( (): void => {
    config.value.model = new Media( 'denfield-app-user/denfield-package-media', activeEnvironment.value.meta.api.url );
} );


const toggleModalOpen = ( payload: any ): any => store.dispatch( "media/toggleModalOpen", payload );

const replaceFile = ( file: any ): void => {
    emit( 'replace', file );
}

/**
 * Fetches folders from the API.
 *
 * @returns {Promise<void>}
 */
const getFolders = async (): Promise<void> => {
    try {
        await store.dispatch( "media/getFolders" );
    } catch ( error ) {
        config.value.error = true;
    }
}

/** Fetches files from api */
const searchFiles = async (): Promise<void> => {
    try {
        await store.dispatch( "media/setLoading", true );
        await store.dispatch("media/searchFiles", { filters: filters.value })
    } catch ( error ) {
        config.value.error = true;
    } finally {
        await store.dispatch( "media/setLoading", false );
    }
}

/** debounce the search input */
const timer = ref(0);
const handleSearchInput = (): void => {
    clearTimeout(timer.value);
    timer.value = setTimeout( async () => {
        await store.dispatch('media/setSearchTerm', searchTerm.value);
        searchFiles()
    }, 500);
}

const applyFilters = async () => {
    searchFiles();
}

/** toggles the search feature for all files and all folders */
const toggleSearchAll = async (): Promise<void> => {
    await store.dispatch( "media/setSearchAll", allFilesSearchMode.value);

    if( allFilesSearchMode.value === true ) {
        await store.dispatch("media/clearFolders");
        await store.dispatch("media/clearFiles");
    } else {
        await getFolders();
    }

    await searchFiles();
    await store.dispatch( "media/setLoading", false );
}

const clearFilters = (): void => {
    filters.value.map((filter) => {
        filter.on = false;
    });
}

const getFilterComponent = ( filter: any ): string => {
    switch ( filter.handle ) {
        case "Greywind\\Apps\\Filters\\Text":
            return 'app-text-filter';
        case "Greywind\\Apps\\Filters\\Date":
            return 'app-date-filter';
        case "Greywind\\Apps\\Filters\\Options":
            return 'app-options-filter';
        case "Greywind\\Apps\\Filters\\Number":
            return 'app-number-filter';
    }

    return 'div';
}

const bulkDeleteFiles = async (): Promise<void> => {
    await store.dispatch( "media/setLoading", true );

    const deleteFiles = selectedFiles.value
                                     .filter( id => files.value.findIndex( file => file.id === id ) !== -1 );

    try {
        await config.value.model.bulkDelete( { files: deleteFiles } );
        await searchFiles();

        toggleAllFilesSelection( false );
    } catch ( { response } ) {
        await store.dispatch(
            "messages/push",
            {
                title:     'Bulk delete failed',
                text:      response.data.message,
                theme:     'error',
                icon:      'fontawesome.circle-exclamation',
                closeable: true,
                autoClose: 10000
            }
        );
    } finally {
        await store.dispatch( "media/setLoading", false );
    }
}

const openPreviewModal = ( file: any ): void => {
    setModalFile( 'preview', file );
}

const setModalFile = ( key: any, file: any ): void => {
    store.dispatch( "media/setModalFile", { key, value: file } );
    toggleModalOpen( key );
}

const cropper = ref( {
    open: false,
    index: 0,
    coordinates: {},
    image: null,
    crop: null,
} );

const cropperModal = ref( {
    open: false,
    uploading: false,
    error: false,
} )

const onCropperSave = async ({ croppedImage, transforms }) => {
    cropper.value.crop = croppedImage;
    cropper.value.open = false;
}

const confirmCrop = () => {
    replaceImageWithCrop( files.value[cropper.value.index], cropper.value.crop )
        .then(async () => {
            await store.dispatch('media/getFiles');
            cropper.value.open = false;
            cropper.value.image = null;
            cropper.value.index = null;
            cropper.value.crop = null;

            cropperModal.value.error = false;
            cropperModal.value.open = false;
        } )
        .catch(() => {
            cropperModal.value.error = true;
        });
}

const toBase64 = async ( file: File ) => new Promise( (resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
} );

const downloadMedia = async ( media) => new Promise ( async ( resolve, reject ) => {
    config.value.model.download( media.id )
        .then(( response ) => {
            resolve( response.data );
        })
        .catch(( error ) => {
            reject( error );
        });
});
const openCropper = async ( index: number ) => {
    const media = filteredFiles.value[index];
    const image = await downloadMedia( media )
        .then( async ( file: File ) => {
            const blob = new Blob([file], { type: media.mime_type });
            return await toBase64( new File([blob], media.file_name, { type: media.mime_type }) )
        } );

    cropperModal.value.open = true;
    cropper.value.index = index;
    cropper.value.open = true;
    cropper.value.image = image;
}

const replaceImageWithCrop = ( media, crop ) => {
    return new Promise(async ( resolve, reject ) => {
        const replacement = await base64ToFile( crop, media.file_name, media.mime_type ).then(result => result);

        cropperModal.value.uploading = true;

        await uploadTempFile( replacement )
            .then(( result ) => {
                config.value.model.replace( media.id, { file: result } )
                    .then(async () => {
                        cropperModal.value.uploading = false;
                        resolve();
                    })
                    .catch(() => {
                        cropperModal.value.uploading = false;
                        reject();
                    });
            })
            .catch(( error ) => {
                cropperModal.value.uploading = false;
                reject();
            });
    });
}

const uploadTempFile = async ( file: File ) => {
    return new Promise(async ( resolve, reject ) => {
        const formData = new FormData();
        formData.append("file", file);

        await config.value.model.uploadTemp( formData )
            .then((result) => {
                resolve(result.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

const base64ToFile = async ( base64Image: any, name: string, type: string) => {
    const res: Response = await fetch(base64Image);
    const blob: Blob = await res.blob();

    return new File([blob], name, { type: type });
};

const handleDownload = async ( media ) => {
    await downloadMedia( media )
        .then(( file ) => {
            const blob = new Blob([file], { type: media.mime_type });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = media.file_name; // Specify the desired file name
            link.click();
        })
        .catch(( error ) => {
            console.log( error );
        });
}

return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_boolean_field = _resolveComponent("boolean-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(mode) !== 'field')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleAllFilesSelection)( !_unref(allFilesSelected) ))),
              class: "items-center flex"
            }, [
              _createVNode(_component_x_icon, {
                icon: "fontawesome.circle-check",
                "fa-type": "fas",
                class: "w-5 h-5"
              }),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(allFilesSelected) ? 'Unselect' : 'Select') + " All", 1),
              (_unref(selectedFiles).length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(selectedFiles).length) + ")", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_unref(selectedFiles).length && _unref(mode) !== 'field')
          ? (_openBlock(), _createBlock(_unref(ButtonGroup), {
              key: 0,
              class: "dark"
            }, {
              default: _withCtx(() => [
                (_unref(selectedFiles).length)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      size: "small",
                      theme: "light",
                      icon: "fontawesome.trash",
                      onClick: bulkDeleteFiles,
                      pill: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(selectedFiles).length)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 1,
                      size: "small",
                      theme: "light",
                      icon: "fontawesome.arrow-down-to-line",
                      pill: false
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(Button), {
                  size: "small",
                  theme: "light",
                  icon: "fontawesome.magnifying-glass",
                  pill: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(config).searching = !_unref(config).searching))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(Button), {
              key: 1,
              size: "small",
              theme: "light",
              icon: "fontawesome.magnifying-glass",
              pill: false,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(config).searching = !_unref(config).searching))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", null, [
          _createVNode(_unref(Button), {
            size: "small",
            theme: "light",
            icon: "fontawesome.filter",
            pill: false,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(config).displayFilters = !_unref(config).displayFilters)),
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "enter-class": "'transition ease-out duration-100'",
            "enter-active-class": "transform opacity-0 scale-95",
            "enter-to-class": "transform opacity-100 scale-100",
            "leave-class": "'transition ease-in duration-75'",
            "leave-active-class": "transform opacity-100 scale-100",
            "leave-to-class": "transform opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Button), {
                    size: "xsmall",
                    theme: "light",
                    pill: false,
                    onClick: clearFilters
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _hoisted_15,
                  _createVNode(_unref(Button), {
                    size: "xsmall",
                    theme: "theme",
                    pill: false,
                    onClick: _cache[4] || (_cache[4] = () => {
                                        _unref(config).displayFilters = false;
                                        applyFilters();
                                    })
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filters.value, (filter, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "dark:text-white"
                    }, [
                      _createElementVNode("label", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "dark:bg-gray-bluer-400 dark:border-gray-bluer-200 focus:ring-theme-500 h-4 w-4 text-theme-600 border-gray-300 rounded",
                          "onUpdate:modelValue": ($event: any) => ((filter.on) = $event)
                        }, null, 8, _hoisted_19), [
                          [_vModelCheckbox, filter.on]
                        ]),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(filter.name), 1)
                      ]),
                      (filter.on)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["py-2 px-4 bg-gray-blue-200 dark:bg-gray-bluer-500 dark:text-white", { 'rounded-b-md': i === filters.value.length-1 }])
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(getFilterComponent(filter)), {
                              data: filter,
                              modelValue: filters.value[i],
                              "onUpdate:modelValue": ($event: any) => ((filters.value[i]) = $event)
                            }, null, 8, ["data", "modelValue", "onUpdate:modelValue"]))
                          ], 2))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ], 512), [
                [_vShow, _unref(config).displayFilters]
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(ButtonGroup), { class: "dark" }, {
          default: _withCtx(() => [
            (_unref(mode) !== 'field')
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  size: "small",
                  theme: _unref(config).view === 'table' ? 'theme' : 'light',
                  icon: "fontawesome.table",
                  pill: false,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(config).view = 'table'))
                }, null, 8, ["theme"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(Button), {
              size: "small",
              theme: _unref(config).view === 'grid' ? 'theme' : 'light',
              icon: "fontawesome.grid",
              pill: false,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(config).view = 'grid'))
            }, null, 8, ["theme"]),
            _createVNode(_unref(Button), {
              size: "small",
              theme: _unref(config).view === 'list' ? 'theme' : 'light',
              icon: "fontawesome.list",
              pill: false,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(config).view = 'list'))
            }, null, 8, ["theme"])
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(config).searching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_x_icon, {
                icon: "fontawesome.magnifying-glass",
                class: "h-5 w-5"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "block w-full bg-white dark:bg-gray-bluer-700 border-none rounded-2xl shadow-sm py-3 pl-14 pr-3 text-sm dark:text-gray-blue-500 placeholder-gray-bluer-50 focus:outline-none focus:text-gray-bluer-600 dark:focus:text-gray-blue-100 focus:placeholder-gray-bluer-400 dark:focus:plaeholder-gray-blue-400 focus:ring-1 focus:ring-theme focus:border-theme",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchTerm).value = $event)),
              placeholder: "Search files and folders...",
              onInput: handleSearchInput
            }, null, 544), [
              [_vModelText, searchTerm.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", { onClick: toggleSearchAll }, [
              _createVNode(_component_boolean_field, {
                modelValue: allFilesSearchMode.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((allFilesSearchMode).value = $event)),
                style: {"margin-bottom":"0"},
                field: {
                            value: allFilesSearchMode.value,
                            required: false,
                            name: 'toggle_search_all',
                        }
              }, null, 8, ["modelValue", "field"])
            ]),
            _hoisted_25
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_unref(Loader), {
            class: "text-theme-500",
            width: "80",
            height: "80",
            "background-colour": "bg-white dark:bg-gray-bluer-800 bg-opacity-100"
          })
        ]))
      : (( _unref(allFiles).length || _unref(backPath) ) && !emptySearch.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_unref(config).view === 'table')
              ? (_openBlock(), _createBlock(_unref(MediaFilesTable), {
                  key: 0,
                  onPreview: openPreviewModal,
                  onReplace: replaceFile,
                  "search-all-mode": allFilesSearchMode.value
                }, null, 8, ["search-all-mode"]))
              : (_unref(config).view === 'grid')
                ? (_openBlock(), _createBlock(_unref(MediaFilesGrid), {
                    key: 1,
                    "can-delete-folder": __props.canDeleteFolder,
                    "can-replace": true,
                    "can-download": __props.canDownload,
                    "search-all-mode": allFilesSearchMode.value,
                    onPreview: openPreviewModal,
                    onReplace: replaceFile,
                    onCrop: openCropper,
                    onDownload: handleDownload
                  }, null, 8, ["can-delete-folder", "can-download", "search-all-mode"]))
                : (_openBlock(), _createBlock(_unref(MediaFilesList), {
                    key: 2,
                    onPreview: openPreviewModal,
                    onReplace: replaceFile,
                    "search-all-mode": allFilesSearchMode.value
                  }, null, 8, ["search-all-mode"]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_unref(BlankCanvas), { class: "w-3/4 lg:w-1/2 mt-12 h-auto mx-auto text-gray-bluer-300 dark:text-gray-blue-500" })
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_unref(Modal), {
        open: _unref(modals).preview.open,
        "width-classes": "sm:max-w-5xl sm:w-full",
        onClose: _cache[11] || (_cache[11] = ($event: any) => (toggleModalOpen('preview'))),
        "inner-border": true,
        style: {"z-index":"9999999!important"}
      }, {
        title: _withCtx(() => [
          (_unref(modals).preview.file)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_29, _toDisplayString(_unref(modals).preview.file.name || _unref(modals).preview.file.file_name), 1))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_unref(modals).preview.file)
              ? (_openBlock(), _createBlock(_unref(MediaFilesPreview), {
                  key: 0,
                  file: _unref(modals).preview.file,
                  onClose: _cache[10] || (_cache[10] = ($event: any) => (toggleModalOpen('preview')))
                }, null, 8, ["file"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_unref(Modal), {
        open: cropperModal.value.open,
        "width-classes": "sm:max-w-5xl sm:w-full",
        onClose: _cache[13] || (_cache[13] = () => cropperModal.value.open = false),
        "inner-border": true,
        style: {"z-index":"9999999!important"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_30, [
            (cropper.value.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_x_icon, {
                        icon: "fontawesome.triangle-exclamation",
                        "fa-type": "fas",
                        class: "h-7 w-7"
                      })
                    ]),
                    _hoisted_34
                  ])
                ]))
              : _createCommentVNode("", true),
            (!cropper.value.open && cropper.value.crop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_x_icon, {
                          icon: "fontawesome.crop",
                          "fa-type": "fas",
                          class: "h-7 w-7"
                        })
                      ]),
                      _hoisted_39
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("img", {
                      src: cropper.value.crop,
                      class: "w-1/2"
                    }, null, 8, _hoisted_41)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_unref(Button), {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (openCropper(cropper.value.index)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_43
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), { onClick: confirmCrop }, {
                      default: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (cropper.value.open && cropper.value.index < _unref(files).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_unref(MediaEditor), {
                    image: cropper.value.image,
                    "image-type": _unref(files)[cropper.value.index].mime_type,
                    onApply: onCropperSave
                  }, null, 8, ["image", "image-type"])
                ]))
              : _createCommentVNode("", true),
            (cropperModal.value.uploading)
              ? (_openBlock(), _createBlock(_unref(Loader), {
                  key: 3,
                  class: "text-theme-500",
                  background: "rgba(0,0,0,0.5)"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]))
  ]))
}
}

})